import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const PILLARS = [
  { word: "HYDRATE", note: "Deep moisture for lip tissue", testid: "pillar-card-hydrate" },
  { word: "REVITALISE", note: "A revitalising lip-care concept", testid: "pillar-card-revitalise" },
  { word: "SMOOTH", note: "Smoother-looking lip surface", testid: "pillar-card-smooth" },
  { word: "REFRESH", note: "A fresh, healthy-looking glow", testid: "pillar-card-refresh" },
  { word: "BOOST", note: "Your lips — only better", testid: "pillar-card-boost" },
];

const Pillars = () => (
  <section data-testid="pillars-section" className="bg-[#F4EBE6] py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Beyond lip filler</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-serif font-light text-[#1C1417] text-4xl sm:text-6xl tracking-tight mt-5 max-w-3xl text-balance leading-[1.04]">
          Skinfill Bacio focuses on the <span className="italic text-[#A31D4F]">quality</span> of your lips — not simply
          their volume.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {PILLARS.map((p, i) => (
          <motion.div
            key={p.word}
            data-testid={p.testid}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.09, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -8 }}
            className="group relative rounded-3xl bg-white/70 border border-[#EADECE] p-7 sm:p-8 overflow-hidden cursor-default"
          >
            <div className="absolute inset-x-0 bottom-0 h-0 group-hover:h-full bg-gradient-to-t from-[#FCE7EE] to-transparent transition-[height] duration-500 ease-out" />
            <p className="relative font-mono text-[10px] tracking-[0.3em] text-[#A31D4F]">0{i + 1}</p>
            <p className="relative font-serif text-2xl sm:text-[26px] text-[#1C1417] mt-10 sm:mt-24 group-hover:italic group-hover:text-[#A31D4F] transition-colors duration-300">
              {p.word}
            </p>
            <p className="relative text-xs text-[#6E6266] font-light mt-3 leading-relaxed">{p.note}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Pillars;
